import React from 'react';

const DeleteInline = ({ size = '20', fill = '#CE181E', height = '20' }) => {
  return (
    <svg width={size} height={height} viewBox={`0 0 ${size} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 18H13V4H1V18ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z" fill={fill} />
    </svg>
  );
};

export default DeleteInline;